// extracted by mini-css-extract-plugin
export var Flex = "Flex-module--Flex--46d6b";
export var FlexItem = "Flex-module--Flex-item--f5115";